// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 1013); hand-edits allowed (see docs/architecture.md)

/** `this.FLAGS_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_FLAGS_DEF(): any {
  return {
    "flag_russia": {
      "limit": 1,
      "level": 1,
      "id": 1,
      "gold": 100,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг России"
    },
    "flag_usa": {
      "limit": 1,
      "level": 1,
      "id": 2,
      "gold": 150,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг США"
    },
    "flag_ukraine": {
      "limit": 1,
      "level": 1,
      "id": 3,
      "gold": 250,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг Украины"
    },
    "flag_japan": {
      "limit": 1,
      "level": 1,
      "id": 4,
      "gold": 300,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг Японии"
    },
    "flag_china": {
      "limit": 1,
      "level": 1,
      "id": 5,
      "gold": 300,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг Китая"
    },
    "flag_germany": {
      "limit": 1,
      "level": 1,
      "id": 6,
      "gold": 300,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг Германии"
    },
    "flag_uk": {
      "limit": 1,
      "level": 1,
      "id": 7,
      "gold": 300,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Флаг Великобритании"
    },
    "flag_costa": {
      "limit": 1,
      "level": 1,
      "id": 8,
      "gold": 500,
      "diam": 1,
      "req": "level",
      "req_amnt": 5,
      "name": "Флаг Коста-Рика"
    },
    "flag_lt": {
      "limit": 1,
      "level": 1,
      "id": 9,
      "gold": 800,
      "diam": 1,
      "req": "level",
      "req_amnt": 10,
      "name": "Флаг Латвии"
    },
    "flag_corea": {
      "limit": 1,
      "level": 1,
      "id": 10,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 15,
      "name": "Флаг Кореи"
    },
    "flag_gabon": {
      "limit": 1,
      "level": 1,
      "id": 11,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 20,
      "name": "Флаг Габона"
    },
    "flag_dw": {
      "limit": 1,
      "level": 1,
      "id": 12,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 25,
      "name": "Флаг Швейцарии"
    },
    "flag_af": {
      "limit": 1,
      "level": 1,
      "id": 13,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 30,
      "name": "Флаг Афганистана"
    },
    "flag_kenia": {
      "limit": 1,
      "level": 1,
      "id": 14,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 35,
      "name": "Флаг Кении"
    },
    "flag_viet": {
      "limit": 1,
      "level": 1,
      "id": 15,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 40,
      "name": "Флаг Вьетнама"
    },
    "flag_canada": {
      "limit": 1,
      "level": 1,
      "id": 16,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 45,
      "name": "Флаг Канады"
    },
    "flag_mac": {
      "limit": 1,
      "level": 1,
      "id": 17,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 50,
      "name": "Флаг Македонии"
    },
    "flag_sheep": {
      "limit": 1,
      "level": 1,
      "id": 18,
      "gold": 500,
      "diam": 1,
      "req": "achiev",
      "req_amnt": 2,
      "name": "Флаг \"Овца\""
    },
    "flag_3worms": {
      "limit": 1,
      "level": 1,
      "id": 19,
      "gold": 1000,
      "diam": 1,
      "req": "achiev",
      "req_amnt": 4,
      "name": "Флаг \"Червяки\""
    },
    "flag_banana": {
      "limit": 1,
      "level": 1,
      "id": 20,
      "gold": 1200,
      "diam": 2,
      "req": "achiev",
      "req_amnt": 6,
      "name": "Флаг \"Бананы\""
    },
    "flag_rad": {
      "limit": 1,
      "level": 1,
      "id": 21,
      "gold": 2000,
      "diam": 2,
      "req": "achiev",
      "req_amnt": 8,
      "name": "Флаг \"Радиация\""
    },
    "flag_holy": {
      "limit": 1,
      "level": 1,
      "id": 22,
      "gold": 3000,
      "diam": 3,
      "req": "achiev",
      "req_amnt": 10,
      "name": "Флаг \"Святой удар\""
    },
    "flag_ussr": {
      "limit": 1,
      "level": 1,
      "id": 23,
      "gold": 400,
      "diam": 1,
      "req": "career",
      "req_amnt": 10,
      "name": "Флаг СССР"
    },
    "flag_rabbit": {
      "limit": 1,
      "level": 1,
      "id": 24,
      "gold": 600,
      "diam": 1,
      "req": "career",
      "req_amnt": 20,
      "name": "Флаг \"Кролик\""
    },
    "flag_ruby": {
      "limit": 1,
      "level": 1,
      "id": 25,
      "gold": 900,
      "diam": 1,
      "req": "career",
      "req_amnt": 30,
      "name": "Флаг \"Рубин\""
    },
    "flag_zombie": {
      "limit": 1,
      "level": 1,
      "id": 26,
      "gold": 1100,
      "diam": 2,
      "req": "career",
      "req_amnt": 40,
      "name": "Флаг \"Зомби\""
    },
    "flag_asassin": {
      "limit": 1,
      "level": 1,
      "id": 27,
      "gold": 3000,
      "diam": 2,
      "req": "career",
      "req_amnt": 55,
      "name": "Флаг \"Ассасин\""
    },
    "flag_oon": {
      "limit": 1,
      "level": 1,
      "id": 28,
      "gold": 400,
      "diam": 1,
      "req": "mission",
      "req_amnt": 5,
      "name": "Флаг ООН"
    },
    "flag_rabbit2": {
      "limit": 1,
      "level": 1,
      "id": 29,
      "gold": 600,
      "diam": 1,
      "req": "mission",
      "req_amnt": 8,
      "name": "Флаг \"Кролик II\""
    },
    "flag_devil": {
      "limit": 1,
      "level": 1,
      "id": 30,
      "gold": 900,
      "diam": 1,
      "req": "mission",
      "req_amnt": 13,
      "name": "Флаг \"Дьявол\""
    },
    "flag_bos": {
      "limit": 1,
      "level": 1,
      "id": 31,
      "gold": 1100,
      "diam": 2,
      "req": "mission",
      "req_amnt": 17,
      "name": "Флаг Братства Стали"
    },
    "flag_spec": {
      "limit": 1,
      "level": 1,
      "id": 32,
      "gold": 4000,
      "diam": 4,
      "req": "mission",
      "req_amnt": 20,
      "name": "Флаг Спецназа"
    }
  };
}
